import { Grid, Stack, Typography, Button } from '@mui/material';
import { ICONS } from 'src/assets/library';

const PageHeader = ({ pageTitle, onButtonClick, buttonTitle, children, icon }) => {
  return (
    <Stack direction={'row'} flexWrap={'wrap'} justifyContent={'space-between'}>
      <Typography variant="h4" color={'primary'}>
        {pageTitle}
      </Typography>
      <Grid display={'flex'} alignItems={'center'} gap={2} flexWrap={'wrap'}>
        {buttonTitle && (
          <Grid>
            <Button variant="contained" size="small" startIcon={icon || ICONS.add} onClick={onButtonClick}>
              {buttonTitle}
            </Button>
          </Grid>
        )}
        {children}
      </Grid>
    </Stack>
  );
};

export default PageHeader;
